import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import ProjectInner from './Project';

class Project extends React.PureComponent<
  RouteComponentProps<{ projectType: string; projectSlug: string }>
> {
  render() {
    return (
      <ProjectInner
        projectType={this.props.match.params.projectType}
        projectSlug={this.props.match.params.projectSlug}
        archived={true}
      />
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/scenes/Project/Archive.tsx